// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_89-4";
export var collapsed = "_89-1";
export var headerBar = "_89-0";
export var leftHeaderContent = "_89-3";
export var subjectContainer = "_89-2";